import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=95cb9d0e&scoped=true&"
import script from "./Detail.vue?vue&type=script&lang=js&"
export * from "./Detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95cb9d0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95cb9d0e')) {
      api.createRecord('95cb9d0e', component.options)
    } else {
      api.reload('95cb9d0e', component.options)
    }
    module.hot.accept("./Detail.vue?vue&type=template&id=95cb9d0e&scoped=true&", function () {
      api.rerender('95cb9d0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/result/Detail.vue"
export default component.exports